<template>
  <v-dialog max-width="500px" persistent v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark dense>
        <v-toolbar-title class="headline">{{formTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false) && $emit('setEditIndex',-1)">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto;">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- <v-layout row wrap>
          <v-flex xs12 md6>-->
          <v-text-field
            label="Add-on name TH"
            v-model="form.addon_title_th"
            hide-details
            :rules="[v => !!v || 'name is required']"
            :loading="loading_message"
          ></v-text-field>
          <v-text-field
            label="Add-on name EN"
            :loading="loading_message"
            v-model="form.addon_title_en"
            hide-details
          ></v-text-field>
          <v-text-field
            label="Add-on name CN"
            :loading="loading_message"
            v-model="form.addon_title_cn"
            hide-details
          ></v-text-field>
          <v-layout row wrap class="mt-2">
            <v-flex xs6 style="position:relative;">
              <v-layout row>
                <label class="text-icon">Icon :</label>
                <img
                  height="40px"
                  width="40px"
                  :src="form.addon_image"
                  alt
                  v-if="form.addon_image != null"
                  class="ml-3 mt-1"
                />
                <v-card
                  v-if="form.addon_image == null"
                  height="40px"
                  width="40px"
                  color="grey"
                  class="ml-3 mt-1 text-xs-center pt-2"
                >
                  <v-icon color="white">photo</v-icon>
                </v-card>
                <v-btn
                  class="black--text ml-3"
                  @click="$refs.LogoInput.click()"
                >{{form.addon_image == null ? 'add icon' : 'edit icon'}}</v-btn>
              </v-layout>
            </v-flex>
            <v-flex>
              <input
                style="display:none;"
                @change="onLogoSelected"
                type="file"
                ref="LogoInput"
                accept="image/*"
              />
            </v-flex>
          </v-layout>
          <!-- </v-flex>
          <v-flex xs12 md6>-->
          <v-data-table
            :headers="headers"
            :items="form.addon_relation"
            :pagination.sync="pagination"
            class="elevation-1 mt-2"
            hide-actions
            :loading="loading_message"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.vehicle_title_th }}</td>
              <td class="text-xs-center">
                <v-text-field
                  label="Price"
                  v-model.number="props.item.addon_price"
                  hide-details
                  style="padding-bottom:10px;"
                ></v-text-field>
              </td>
              <td class="justify-center layout px-0">
                <v-switch
                  v-model="props.item.addon_relation_check"
                  color="primary"
                  style="max-width:50px;margin-top:17px;"
                ></v-switch>
              </td>
            </template>
          </v-data-table>
          <!-- </v-flex>
          </v-layout>-->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          flat
          @click="$emit('setDialog', false) && $emit('setEditIndex',-1)"
          :disabled="loading_message"
        >Cancel</v-btn>
        <v-btn color="green" flat @click="save()" :disabled="loading_message || isEditAddon">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["dialog", "editedIndex", "form", "loading_message"],
  data() {
    return {
      saving: false,
      change_image: 0,
      pagination: {
        rowsPerPage: 10
      },
      valid: true,
      headers: [
        {
          text: "Vehicle name",
          value: "name",
          align: "center",
          sortable: false
        },
        { text: "Price", value: "price", align: "center", sortable: false },
        { text: "Action", value: "action", align: "center", sortable: false }
      ],
      addons: [
        {
          name: "รถบรรทุก",
          price: "Active",
          action: ""
        },
        {
          name: "รถมอเตอร์ไซค์",
          price: "Inactive",
          action: ""
        }
      ]
    };
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.change_image = 0;
      } else {
        this.$refs.form.reset();
      }
    }
  },
  computed: {
    ...mapGetters(["isEditAddon"]),
    formTitle() {
      return this.editedIndex === -1 ? "New add-on" : "Edit add-on";
    }
  },
  methods: {
    onLogoSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.form.addon_image = reader.result;
      });
      this.change_image = 1;
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    save() {
      if (this.$refs.form.validate()) {
        let obj1 = JSON.parse(JSON.stringify(this.form));
        let id_addon = [];
        for (let val of obj1.addon_relation) {
          if (val.addon_relation_check == false) {
            id_addon.push(val.vehicle_id);
          } else {
            delete val.addon_relation_check;
            delete val.vehicle_title_th;
          }
        }
        for (let val of id_addon) {
          let index_addon = obj1.addon_relation.findIndex(
            res => res.vehicle_id == val
          );
          obj1.addon_relation.splice(index_addon, 1);
        }
        if (this.change_image == 0) {
          delete obj1.addon_image;
        }
        this.saving = true;
        if (this.editedIndex == -1) {
          this.$store.dispatch("fetchMessAddonBack/addAddon", obj1);
        } else {
          this.$store.dispatch("fetchMessAddonBack/editAddon", obj1);
        }
        this.saving = false;
        this.$emit("setDialog", false);
        this.$emit("setEditIndex", -1);
      }
    }
  }
};
</script>
<style scoped>
.text-icon {
  font-size: 17px;
  margin-top: 10px;
  color: #616a6b;
}
</style>




